import { FilterModalTypes } from '../../../components/FilterModal';

export const securitiesTransferAvailableFilter = [
  {
    type: 'section',
    title: 'Tipos',
    fieldName: 'flow',
    options: [
      { label: 'Entrada', value: 'Incoming' },
      { label: 'Saída', value: 'Outgoing' },
    ],
  },
  {
    type: 'section',
    title: 'Solicitado via',
    fieldName: 'source',
    options: [
      { label: 'B3', value: 'B3' },
      { label: 'Genial', value: 'Genial' },
      { label: 'Outras', value: 'Others' },
    ],
  },
  {
    type: 'section',
    title: 'Status',
    fieldName: 'stage',
    options: [
      { label: 'Solicitada', value: 'Requested' },
      { label: 'Concluída', value: 'Completed' },
      { label: 'Em aprovação', value: 'Approving' },
      { label: 'Em análise', value: 'Analyzing' },
      { label: 'Em execução', value: 'Executing' },
      { label: 'Pendente', value: 'Pending' },
      { label: 'Expirada', value: 'Expired' },
      { label: 'Cancelada', value: 'Canceled' },
    ],
  },
] as FilterModalTypes.FilterType[];
